// extracted by mini-css-extract-plugin
export default {"root":"ExclusionTypeSelectionMenu_root__YdGqV","menuTitle":"ExclusionTypeSelectionMenu_menuTitle__+W4hz"};